import { useContext } from "react"
import { useMutation, useQueryClient } from "react-query"
import { setTranslation } from "~/actions/translations"
import AppContext from "../contexts/App"

const getSnackMessage = (isDeletion, translationId) => {
  if (isDeletion) {
    return ["Translation deleted", "Error deleting translation"]
  }
  return translationId
    ? ["Translation updated", "Error updating translation"]
    : ["Translation added", "Error adding translation"]
}

const updateTranslationsCache = (
  queryClient,
  typeData,
  translationId,
  res,
  isDeletion,
) => {
  const queryKey = [
    typeData.type.endsWith("s") ? typeData.type.slice(0, -1) : typeData.type,
    typeData.type === "docs" ? typeData.type_id.toString() : typeData.type_id,
  ]

  queryClient.setQueryData(queryKey, (oldData) => {
    if (!oldData) return

    const updatedData = { ...oldData }

    if (isDeletion) {
      updatedData.translations = updatedData.translations.filter(
        (x) => x.id !== translationId,
      )
    } else if (translationId) {
      updatedData.translations = updatedData.translations.map((x) =>
        x.id === translationId ? res : x,
      )
    } else {
      updatedData.translations = [...updatedData.translations, res]
    }

    return updatedData
  })
}

const useSetTranslationMutation = (typeData) => {
  const queryClient = useQueryClient()
  const { openSnackBar } = useContext(AppContext)

  const mutation = useMutation(
    async (data) => {
      const isDeletion = !data.locale
      const translationId = data.id || null

      return {
        res: await setTranslation(typeData, data),
        translationId,
        isDeletion,
      }
    },
    {
      onSuccess: ({ res, translationId, isDeletion }) => {
        updateTranslationsCache(
          queryClient,
          typeData,
          translationId,
          res,
          isDeletion,
        )

        openSnackBar({
          message: getSnackMessage(isDeletion, translationId)[0],
        })
      },
      onError: (_, { isDeletion, translationId }) => {
        openSnackBar({
          message: getSnackMessage(isDeletion, translationId)[1],
        })
      },
    },
  )

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}

export default useSetTranslationMutation
